import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { UdcAdd } from '../udc-add/udc-add';   
import { UdcEdit } from '../udc-edit/udc-edit'; 
import { UdcsService } from '../../Service/udcs-service';
import { ToastService } from '../../Service/toast-service';

export interface UdcRecord {
  id: number;
  udcSystem: string;  // Ej: 'AUTOS', 'ROLES', 'PORTAL'
  udcKey: string;     // Ej: 'MARCAS', 'AVISOS'
  description: string; // Descripción larga
  strValue1?: string; // Clave alfanumérica o tipo alerta
  strValue2?: string; // Título o valor secundario
  booleanValue?: boolean; // Activo / Inactivo
}

@Component({
  selector: 'app-udc-list',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule],
  templateUrl: './udc-list.html',
  styleUrl: './udc-list.css',
})
export class UdcList implements OnInit {
  
  //udcs : Udcs[] = [];
  catUdcs: UdcRecord[] = [];
  udcsFiltradas: UdcRecord[] = [];
  filtroTexto: string = '';

  // 🚀 LA SOLUCIÓN CORE: Hacemos visible la librería Math para la plantilla HTML
  // Esto disuelve de raíz el error de propiedad inexistente ts(2339).
  protected readonly Math = Math;

  // =========================================================================
  // 🎛️ VARIABLES CORE PARA TU NUEVA PAGINACIÓN REACIVA
  // =========================================================================
  paginaActual: number = 1;
  registrosPorPagina: number = 10; // Puedes cambiarlo a 5, 15 o 20 según tu pantalla
  totalPaginas: number = 1;

  constructor(
    private udcService: UdcsService,
    public toastService: ToastService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.cargarCatalogoMaestro();
  }

  cargarCatalogoMaestro(): void {
    console.log('📶 [JDE TELEMETRÍA] 1. Solicitando tabla universal UDC al Backend (api/udcs)...');
    this.udcService.getUdcList().subscribe({
      next: (data: any[]) => {
        // 🔥 LOGS DE TELEMETRÍA CRÍTICOS RESTAURADOS AL 100%
        console.log('📥 [JDE TELEMETRÍA] 2. Respuesta cruda recibida del Backend. Longitud del array:', data.length);
        console.log('📋 [JDE TELEMETRÍA] 3. Contenido íntegro del array devuelto por Java:', data);

        this.catUdcs = data.map((item, index) => {
          const record = {
            id: item.id,
            udcSystem: item.udcSystem || item.udcsystem || '',
            udcKey: item.udcKey || item.udckey || '',
            description: item.description || '',
            strValue1: item.strValue1 || item.strvalue1 || '',
            strValue2: item.strValue2 || item.strvalue2 || '',
            booleanValue: item.booleanValue !== undefined ? item.booleanValue : true
          };
          
          if (index === 0 || index === data.length - 1) {
            console.log(`📦 [JDE TELEMETRÍA] Renglón Mapeado de muestra [Índice ${index}]:`, record);
          }
          return record;
        });

        console.log('🔄 [JDE TELEMETRÍA] 4. Ejecutando motor de búsqueda filtrarUdcs()...');
        this.filtrarUdcs();

        this.cdr.markForCheck();
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('❌ [JDE TELEMETRÍA] Fallo crítico de comunicación por red:', err);
        this.toastService.showDanger('Fallo de Red', 'No se pudo descargar la tabla universal UDC.');
      }
    });
  }    


  filtrarUdcs(): void {
    const busqueda = this.filtroTexto.trim().toUpperCase();
    
    if (!busqueda) {
      this.udcsFiltradas = [];
      this.udcsFiltradas = [...this.catUdcs];
    } else {
      this.udcsFiltradas = this.catUdcs.filter(u => {
        return u.udcSystem.toUpperCase().includes(busqueda) ||
               u.udcKey.toUpperCase().includes(busqueda) ||
               u.description.toUpperCase().includes(busqueda) ||
               (u.strValue1 && u.strValue1.toUpperCase().includes(busqueda));
      });
    }

    this.paginaActual = 1;
    this.calcularTotalPaginas();

    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  // =========================================================================
  // ⚙️ MATEMÁTICA DE CONTROL DE PÁGINAS INTERNAS
  // =========================================================================
  
  calcularTotalPaginas(): void {
    this.totalPaginas = Math.ceil(this.udcsFiltradas.length / this.registrosPorPagina) || 1;
    this.cdr.detectChanges();
  }

  get udcsPaginadas(): UdcRecord[] {
    const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
    const fin = inicio + this.registrosPorPagina;
    return this.udcsFiltradas.slice(inicio, fin);
  }

  cambiarPagina(nuevaPagina: number): void {
    if (nuevaPagina >= 1 && nuevaPagina <= this.totalPaginas) {
      this.paginaActual = nuevaPagina;
      this.cdr.detectChanges();
    }
  }


  abrirAltaModal(): void {
    console.log('🚀 [JDE TELEMETRÍA] Lanzando ventana modal UdcAdd...');
    const dialogRef = this.dialog.open(UdcAdd, { width: '550px', disableClose: true });
    
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('🚪 [JDE TELEMETRÍA] Ventana Modal Cerrada de forma legal.');

      // 🚀 BLINDAJE SAAS TOTAL:
      // Quitamos la condición rígida 'if (result)' para que no se congele si el Backend devuelve vacío.
      // Ahora, al cerrarse el modal tras presionar "Guardar", el sistema siempre limpiará la búsqueda,
      // disparará tu Toast flotante verde corporativo y obligará a la red a traer la data fresca de MySQL.
      //this.filtroTexto = '';
      
/*       this.toastService.showSuccess(
        'Catálogo Registrado', 
        `El registro de catálogo ha sido insertado en el sistema de forma exitosa.`
      ); */
      
      //console.log('📡 [JDE TELEMETRÍA] Disparando refresco automático directo por red...');
      //this.cargarCatalogoMaestro();

      // 🚀 CANDADO EXCLUSIVO UX: Si el usuario presionó Cancelar o cerró la ventana,
      // 'result' será false o null. Abortamos de inmediato en absoluto silencio técnico.
      if (result === false || result === null || result === undefined) {
        console.log('❌ [JDE TELEMETRÍA] Alta cancelada por el operador. Saliendo sin alertas.');
        return;
      }

      // Si pasó la aduana, significa que sí presionó "Guardar" de forma legítima
      this.filtroTexto = '';
      this.toastService.showSuccess('Catálogo Registrado', `El registro fue insertado en MySQL con éxito.`);
      this.cargarCatalogoMaestro();
    });
  }

  abrirEdicionModal(record: UdcRecord): void {
    const dialogRef = this.dialog.open(UdcEdit, {
      data: { ...record }, 
      width: '550px',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toastService.showSuccess('Catálogo Actualizado', `Cambios aplicados con éxito.`);
        this.cargarCatalogoMaestro();
      }
    });
  }
}

